import { Injectable } from '@angular/core';
import { DataService } from '../../data.service';
import { BillingInvoiceEditInfo } from '../../../model/billing/billing-invoice-edit-info';
import { BillingInvoiceItemEditInfo } from '../../../model/billing/billing-invoice-item-edit-info';
import { InvoiceNumberBookPoint } from '../../../model/invoice-number-book-point';
import { ClientFilter } from 'src/app/model/client-filter';
import { BillingInvoice } from 'src/app/model/billing/billing-invoice';
import { BillingInvoiceCreateResponse } from 'src/app/model/billing/billing-invoice-create-response';
import { ClientSearch } from 'src/app/model/client-search';

@Injectable({
  providedIn: 'root'
})
export class BillingInvoiceCreditEntityService {

  private readonly getBillingInvoiceEditInfoEndPoint: string = '/billingInvoiceCredit/getBillingInvoiceEditInfo/';
  private readonly getBillingInvoiceItemsEndPoint: string = '/billingInvoiceCredit/getBillingInvoiceItems/';
  private readonly createExcelCreditEndPoint: string = '/billingInvoiceCredit/createExcelCredit/';
  private readonly billingInvoiceCreateEndPoint: string = '/billingInvoiceCredit/billingInvoiceCreate/';
  private readonly billingInvoiceItemEditInfosAdjustmentEndPoint: string = '/billingInvoiceCredit/billingInvoiceItemEditInfosAdjustment/';

  constructor( private dataService: DataService ) { }

  async billingInvoiceItemEditInfosAdjustment( base64File: string, items: BillingInvoiceItemEditInfo[] ): Promise<BillingInvoiceItemEditInfo[]> {
    const params = { FileBase64: base64File, BillingInvoiceItemEditInfos: items };
    return await this.dataService.post<BillingInvoiceItemEditInfo[]>(
      this.billingInvoiceItemEditInfosAdjustmentEndPoint, params).toPromise();
  }

  async createExcelCredit( billingInvoiceItemEditInfos: BillingInvoiceItemEditInfo[] ): Promise<string> {
    return await this.dataService.post<string>(this.createExcelCreditEndPoint,
       billingInvoiceItemEditInfos).toPromise();
  }

  async getBillingInvoiceEditInfo( invoiceId: number, sectorId: number ): Promise<BillingInvoiceEditInfo> {
    const params = { invoiceId: invoiceId, sectorId: sectorId };
    return await this.dataService.get<BillingInvoiceEditInfo>(this.getBillingInvoiceEditInfoEndPoint, params)
                     .toPromise();
  }

  async getBillingInvoiceItems( invoiceId: number ): Promise<BillingInvoiceItemEditInfo[]> {
    const params = { invoiceId: invoiceId };
    return await this.dataService.get<BillingInvoiceItemEditInfo[]>(this.getBillingInvoiceItemsEndPoint, params)
                     .toPromise();
  }

  async billingInvoiceCreate(preBillingId: number, clientSearch: ClientSearch,
    invoiceNumberBookPoint: InvoiceNumberBookPoint, billingInvoice: BillingInvoice,
    medicalAppointmentProcedureExcludeIds: number[],
    items: BillingInvoiceItemEditInfo[]): Promise<BillingInvoiceCreateResponse> {

    const params = { PreBillingId: preBillingId,
      IsRejected: billingInvoice.IsRejected,
      Description:  billingInvoice.Description,
      InvoiceDate: billingInvoice.InvoiceDate,
      InvoiceExpiredDate: billingInvoice.InvoiceExpiredDate,
      Amount: billingInvoice.Amount,
      InvoiceLabelType:  billingInvoice.InvoiceLabelType,
      TaxpayerType:  billingInvoice.TaxpayerType,
      InvoicePoint: billingInvoice.InvoicePoint,
      ClientSearch: clientSearch,
      InvoiceTaxes: billingInvoice.InvoiceTaxes,
      BillingInvoicePeriod: billingInvoice.BillingInvoicePeriod,
      InvoiceNumberBookPoint: invoiceNumberBookPoint,
      MedicalAppointmentProcedureExcludeIds: medicalAppointmentProcedureExcludeIds,
      OriginalBillingInvoiceId: billingInvoice.OriginalBillingInvoiceId,
      Items: items
    };

    return await this.dataService.post<BillingInvoiceCreateResponse>(this.billingInvoiceCreateEndPoint, params)
    .toPromise();
  }
}
